export interface Vehicle {
  id: number;
  make: string;
  model: string;
  year: number;
  licensePlate?: string;
  vin?: string | null;
  type: VehicleType;
  vehicleClass: VehicleClass;
  status: VehicleStatus;
  dailyRate: string | number;
  /** Vehicle mileage in kilometers (km). IMPORTANT: All mileage values must be in kilometers, never in miles. */
  mileage: number;
  purchasePrice?: string | number | null;
  purchaseDate?: string | null;
  purchaseMileageKm?: number | null;
  color: string;
  fuelType: string;
  transmission: string;
  engineSize?: string;
  seatingCapacity: number;
  luggageCapacity?: number;
  features: string[];
  description: string;
  imageUrl?: string;
  imageUrls: string[];
  
  // Amenities
  airConditioning?: boolean;
  gpsNavigation?: boolean;
  bluetooth?: boolean;
  usbCharging?: boolean;
  backupCamera?: boolean;
  parkingSensors?: boolean;
  sunroof?: boolean;
  leatherSeats?: boolean;
  
  company: {
    id: number;
    companyName: string;
    email: string;
    phoneNumber: string;
    streetAddress: string;
    city: string;
    state: string;
    postalCode: string;
    country: string;
  };
  isAvailableForRental: boolean;
  isFeatured: boolean;
  pendingReview?: boolean;
  currentLocation: string;
  pickupLocation: string;
  companyLocationId?: number | null;
  companyLocationName?: string | null;
  insuranceIncluded: boolean;
  insuranceDailyRate: number;
  depositRequired: number;
  minimumRentalDays: number;
  maximumRentalDays: number;
  cancellationPolicy: string;
  termsAndConditions: string;
  createdAt: string;
  updatedAt: string;
}

export interface VehicleDocument {
  id: number;
  originalFileName: string;
  contentType: string;
  fileSizeBytes: number;
  fileUrl: string;
  createdAt: string;
}

export enum VehicleType {
  CAR = 'CAR',
  SUV = 'SUV',
  TRUCK = 'TRUCK',
  VAN = 'VAN',
  MOTORCYCLE = 'MOTORCYCLE'
}

export enum VehicleClass {
  ECONOMY = 'ECONOMY',
  COMPACT = 'COMPACT',
  MID_SIZE = 'MID_SIZE',
  FULL_SIZE = 'FULL_SIZE',
  LUXURY = 'LUXURY'
}

export enum VehicleStatus {
  AVAILABLE = 'AVAILABLE',
  RENTED = 'RENTED',
  MAINTENANCE = 'MAINTENANCE',
  OUT_OF_SERVICE = 'OUT_OF_SERVICE',
  RETIRED = 'RETIRED'
}

export interface VehicleCatalogMake {
  id: number | null;
  name: string;
  source: string;
}

export interface VehicleCatalogModel {
  id: number | null;
  makeId: number | null;
  name: string;
  source: string;
}

export interface VehicleCatalogModelSearchParams {
  makeId?: number;
  makeName?: string;
  query?: string;
  limit?: number;
}

export interface VehicleSearchParams {
  companyId?: number;
  type?: VehicleType;
  vehicleClass?: VehicleClass;
  make?: string;
  model?: string;
  minRate?: number;
  maxRate?: number;
  minYear?: number;
  maxYear?: number;
  fuelType?: string;
  transmission?: string;
  minSeating?: number;
  maxSeating?: number;
  location?: string;
  airConditioning?: boolean;
  gpsNavigation?: boolean;
  bluetooth?: boolean;
  backupCamera?: boolean;
  sunroof?: boolean;
  leatherSeats?: boolean;
  startDate?: string;
  endDate?: string;
  pickupLocation?: string;
  returnLocation?: string;
  page?: number;
  size?: number;
  sortBy?: string;
  sortDir?: string;
}
